define("CCAW.OrderTerms.Consent", ["CCAW.OrderTerms.Consent.View"], function (
  ConsentView
) {
  "use strict";

  return {
    mountToApp: function mountToApp(container) {
      // using the 'Layout' component we add a new child view inside the 'Header' existing view
      // (there will be a DOM element with the HTML attribute data-view="Header.Logo")
      // more documentation of the Extensibility API in
      // https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html

      /** @type {LayoutComponent} */
      var layout = container.getComponent("Layout");
      var checkout = container.getComponent("Checkout");

      if (layout) {
        layout.addChildView("CCAW.OrderTerms.Consent.View", function () {
          return new ConsentView({ container: container });
        });
      }

      if (checkout) {
        checkout.on("afterShowContent", function () {
          checkout.getCurrentStep().then(function (step) {
            if (step.url === "review") {
              var submitButton = $('button[data-action="submit-step"]');
              if (submitButton.length) {
                submitButton.prop("disabled", true);
              }
            }
          });
        });

        var Wizard = require("Wizard.View");
        Wizard.prototype.submit = _.wrap(
          Wizard.prototype.submit,
          function (fn) {
            var _proto$attributes, _proto$attributes2;
            var proto = Object.getPrototypeOf(this);

            if (
              proto &&
              proto !== null &&
              proto !== void 0 &&
              proto.attributes &&
              proto !== null &&
              proto !== void 0 &&
              (_proto$attributes = proto.attributes) !== null &&
              _proto$attributes !== void 0 &&
              _proto$attributes.id &&
              (proto === null ||
              proto === void 0 ||
              (_proto$attributes2 = proto.attributes) === null ||
              _proto$attributes2 === void 0
                ? void 0
                : _proto$attributes2.id) === "checkout"
            ) {
              var currentStep = this.wizard.getCurrentStep();

              if (
                currentStep &&
                currentStep.step_url &&
                currentStep.step_url === "review"
              ) {
                var termsCheckBox = $(
                  '[data-action="ccaw_order_terms_agreement"]'
                );
                if (termsCheckBox.length) {
                  var termsCheckBoxChecked = termsCheckBox.is(":checked");

                  if (!termsCheckBoxChecked) {
                    alert(
                      "Please check the box to confirm you agree to our policies before placing your order."
                    );
                    return;
                  } else {
                    fn.apply(this, _.toArray(arguments).slice(1));
                  }
                }
              } else {
                fn.apply(this, _.toArray(arguments).slice(1));
              }
            } else {
              fn.apply(this, _.toArray(arguments).slice(1));
            }
          }
        );
      }
    },
  };
});
